export const dataStructure = {
  project: {
    properties: {
      id: '',
      up: '',
      op: '',
      name: '',
      tech: '',
      stor: '',
      capa: 0,
      chp: '',
      ro: '',
      cfd: '',
      stat: '',
      reg: '',
      auth: '',
      ref: '',
      app: '',
      ucon: '',
      star: '',
      fini: '',
      oper: '',
      hnt: '',
      noc: '',
      blg: '',
      link: ''
    },
    geometry: {
      type: "Point",
      coordinates: [0, 0]
    },
  }
}



export const geoStructure = {
  type: "FeatureCollection",
  crs: { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  features: [
    { "type": "Feature", "properties": { "tech": "Biomass (co-firing)" } }
  ]
}



export const colors = {
  'Advanced Conversion Technologies': '#B71C1C',
  'Air Source Heat Pumps': '#F06292',
  'Anaerobic Digestion': '#4A148C',
  'Battery': '#9575CD',
  'Biogas CHP': '#1A237E',
  'Biomass (co-firing)': '#64B5F6',
  'Biomass (dedicated)': '#01579B',
  'Compressed Air Energy Storage': '#4DD0E1',
  'EfW Incineration': '#004D40',
  'Flywheels': '#81C784',
  'Fuel Cell (Hydrogen)': '#33691E',
  'Gas Boiler': '#DCE775',
  'Gas Fired CHP': '#F57F17',
  'Ground Source Heat Pumps': '#7DF900',
  'Hot Dry Rocks (HDR)': '#E65100',
  'Landfill Gas': '#FF8A65',
  'Large Hydro': '#3E2723',
  'Liquid Air Energy Storage': '#666600',
  'Pumped Storage Hydroelectricity': '#00FFCE',
  'Sewage Sludge Digestion': '#271EFF',
  'Shoreline Wave': '#E600F9',
  'Small Hydro': '#7E0E68',
  'Solar Photovoltaics': '#F9C056',
  'Solar Thermal': '#794A63',
  'Tidal Barrage and Tidal Stream': '#598968',
  'Water Source Heat Pumps': '#D6AAAA',
  'Wind Offshore': '#606DCB',
  'Wind Onshore': '#486784',
  // 'rgb(235,145,202)',
  // 'rgb(202,178,214)',
  // 'rgb(203,201,255)',
  // 'rgb(127,114,189)',
  // 'rgb(108,148,196)',
  // 'rgb(166,206,227)',
  // 'rgb(168,213,214)',
  // 'rgb(127, 186, 185)',
  // 'rgb(94, 128, 98)',
  // 'rgb(143,188,148)',
  // 'rgb(178,223,138)',
  // "hsl(82, 64%, 64%)",
  // "hsl(329, 95%, 90%)",
  // "hsl(299, 32%, 62%)",
  // "hsl(170, 44%, 69%)",
  // "hsl(6, 94%, 72%)",
  // 'rgb(127,114,189)',
}
